// Environment configuration for WHERE2 frontend
// This file is completely agnostic and works in any context
// No hardcoded URLs - everything is resolved at runtime

interface EnvironmentConfig {
  API_BASE_URL: string;
  FRONTEND_URL: string;
  ENVIRONMENT: 'production' | 'test';
}

// Runtime environment detection - completely agnostic
const getEnvironment = (): 'production' | 'test' => {
  const hostname = window.location.hostname;
  console.log('🔍 Environment detection - hostname:', hostname);
  
  if (hostname.includes('test')) {
    console.log('🔍 Environment detected: TEST');
    return 'test';
  }
  
  console.log('🔍 Environment detected: PRODUCTION');
  return 'production';
};

// Build URLs dynamically based on current domain - completely agnostic
const getApiBaseUrl = (): string => {
  const protocol = window.location.protocol;
  const hostname = window.location.hostname;
  
  // For test environment, use test API subdomain
  if (hostname.includes('test')) {
    return `${protocol}//api.where2test.tarsoul.se`;
  } else {
    // For production, use production API subdomain
    return `${protocol}//api.where2.tarsoul.se`;
  }
};

const getFrontendUrl = (): string => {
  const protocol = window.location.protocol;
  const hostname = window.location.hostname;
  return `${protocol}//${hostname}`;
};

// Create the configuration dynamically at runtime
const config: EnvironmentConfig = {
  API_BASE_URL: getApiBaseUrl(),
  FRONTEND_URL: getFrontendUrl(),
  ENVIRONMENT: getEnvironment()
};

// Export the current environment configuration
export { config };

// Helper function to build API URLs - uses relative paths
export const buildApiUrl = (endpoint: string): string => {
  // Remove leading slash if present
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  
  // Use relative URL that gets resolved by the browser
  const fullUrl = `${config.API_BASE_URL}/${cleanEndpoint}`;
  console.log(`🔗 buildApiUrl: ${endpoint} -> ${fullUrl}`);
  return fullUrl;
};

// Log the current environment for debugging
console.log(`🌍 WHERE2 Frontend Environment: ${config.ENVIRONMENT}`);
console.log(`🔗 API Base URL: ${config.API_BASE_URL}`);
console.log(`🌐 Frontend URL: ${config.FRONTEND_URL}`);
